import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login'),
    meta: { unauthorized: true, webpush: false },
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/auth/forget'),
    meta: { unauthorized: true, webpush: false },
  },
  {
    path: '/customerWebSian/dPage.asp',
    name: '고객웹시안1',
    component: () => import('@/views/draft/custWebSian.vue'),
    meta: { unauthorized: true, webpush: false },
  },
  {
    path: '/customerWebSian/dPage_demo.asp',
    name: '고객웹시안2',
    component: () => import('@/views/draft/custWebSian2.vue'),
    meta: { unauthorized: true, webpush: false },
  },
  {
    path: '/Sheet/estimateSheet.asp',
    name: '고객견적서',
    component: () => import('@/views/order/custEstimate.vue'),
    meta: { unauthorized: true, webpush: false },
  },
  {
    path: '/sms/smsSend',
    name: 'SMS발송',
    component: () => import('@/views/sms/smsSend.vue'),
    meta: { webpush: false },
  },
  {
    path: '/sms/emailSend',
    name: '이메일발송',
    component: () => import('@/views/sms/emailSend.vue'),
    meta: { webpush: false },
  },
  {
    path: '/draft/webSianPrint1/:ordNo',
    name: '발주지시서',
    component: () => import('@/views/draft/webSianPrint1.vue'),
  },
  {
    path: '/draft/webSianPrint2/:ordNo',
    name: '출고지시서',
    component: () => import('@/views/draft/webSianPrint2.vue'),
  },
  {
    path: '/draft/webSianPrint3/:startDate',
    name: '이번주출고지시서',
    component: () => import('@/views/draft/webSianPrint3.vue'),
  },
  {
    path: '/draft/quickLabelPrint/:startDate',
    name: '퀵라벨지',
    component: () => import('@/views/draft/quickLabelPrint.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    children: [
      {
        path: '/home',
        name: 'Home2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/dashboard.vue'),
      },
      {
        path: '/info/myInfo',
        name: '정보수정',
        component: () => import('@/views/info/myInfo.vue'),
      },
      {
        path: '/ai/connect',
        name: 'AI 분석 도구 연결',
        component: () => import('@/views/ai/mcpConnect.vue'),
      },
      {
        path: '/work/scheduleMng',
        name: '일정관리',
        component: () => import('@/views/work/scheduleMng_new.vue'),
      },
      // {
      //   path: "/work/scheduleMngNew",
      //   name: "일정관리_new",
      //   component: () => import('@/views/work/scheduleMng_new.vue')
      // },
      {
        path: '/work/mbrYrycMng',
        name: '사내연차관리',
        component: () => import('@/views/work/mbrYrycMng.vue'),
      },
      {
        path: '/work/workMng',
        name: '개인연차관리',
        component: () => import('@/views/work/workMng.vue'),
      },
      {
        path: '/work/workReg',
        name: '연차신청',
        component: () => import('@/views/work/workReg.vue'),
      },
      {
        path: '/work/workReg/:vcatnUseSn',
        name: '연차결재',
        component: () => import('@/views/work/workReg.vue'),
      },
      {
        path: '/work/mbrVcatnUseMng',
        name: '휴가사용관리',
        component: () => import('@/views/work/mbrVcatnUseMng.vue'),
      },
      {
        path: '/work/salesMng',
        name: '영업관리',
        component: () => import('@/views/work/salesMng.vue'),
      },
      {
        path: '/mgr/noticeMng',
        name: '사내게시판',
        component: () => import('@/views/cmm/cmmInq.vue'),
      },
      {
        path: '/mgr/noticeMng/:cmmSn',
        name: '사내게시판 상세',
        component: () => import('@/views/cmm/cmmInq.vue'),
      },
      {
        path: '/order/manageOrd',
        name: '주문접수',
        component: () => import('@/views/order/manageOrd.vue'),
      },
      {
        path: '/order/consultRecord',
        name: '상담기록',
        component: () => import('@/views/order/consultRecord.vue'),
      },
      {
        path: '/order/asMng',
        name: 'AS관리',
        component: () => import('@/views/order/asMng.vue'),
      },
      {
        path: '/order/sampleMng',
        name: '샘플관리',
        component: () => import('@/views/order/sampleMng.vue'),
      },
      {
        path: '/order/sendMng',
        name: '발송관리',
        component: () => import('@/views/order/sendMng.vue'),
      },
      {
        path: '/order/consultReport',
        name: '일일업무 마감보고',
        component: () => import('@/views/order/consultReport.vue'),
      },

      {
        path: '/draft/custMsg',
        name: '고객요청',
        component: () => import('@/views/draft/custMsg.vue'),
      },
      {
        path: '/draft/email',
        name: '발송메일',
        component: () => import('@/views/draft/email.vue'),
      },
      {
        path: '/draft/webSian/:ordNo',
        name: '웹시안작성',
        component: () => import('@/views/draft/webSian.vue'),
      },
      {
        path: '/sms/smsMng',
        name: 'SMS,이메일관리',
        component: () => import('@/views/sms/notiMng.vue'),
      },
      {
        path: '/sms/smsHist',
        name: 'SMS,이메일기록',
        component: () => import('@/views/sms/notiInq.vue'),
      },
      {
        path: '/product/prdMng',
        name: '제품관리',
        component: () => import('@/views/product/prdMng.vue'),
      },
      {
        path: '/product/gold',
        name: '순금제품 시세적용',
        component: () => import('@/views/product/gold.vue'),
      },
      {
        path: '/product/prodGeo',
        name: '상품 GEO 관리',
        component: () => import('@/views/product/prodGeo.vue'),
      },
      {
        path: '/product/faqMng',
        name: 'FAQ 관리',
        component: () => import('@/views/product/faqMng.vue'),
      },
      {
        path: '/agent/partnerMng',
        name: '파트너스관리',
        component: () => import('@/views/agent/partnerMng.vue'),
      },
      {
        path: '/purchase/orderReg',
        name: '발주서생성',
        component: () => import('@/views/purchase/orderReg.vue'),
      },
      {
        path: '/purchase/orderReg/:purchageSn',
        name: '발주서수정',
        component: () => import('@/views/purchase/orderReg.vue'),
      },
      {
        path: '/purchase/orderMng',
        name: '발주서관리',
        component: () => import('@/views/purchase/orderMng.vue'),
      },
      {
        path: '/purchase/corrodeMng',
        name: '부식관리',
        component: () => import('@/views/purchase/corrodeMng.vue'),
      },
      {
        path: '/purchase/orderSchedule',
        name: '발주달력',
        component: () => import('@/views/purchase/orderSchedule.vue'),
      },
      {
        path: '/purchase/receiverMng',
        name: '협력업체관리',
        component: () => import('@/views/purchase/receiverMng.vue'),
      },
      {
        path: '/purchase/coopMng',
        name: '회사관리업체',
        component: () => import('@/views/purchase/coopMng.vue'),
      },
      {
        path: '/purchase/senderMng',
        name: '발신처관리',
        component: () => import('@/views/purchase/senderMng.vue'),
      },
      //
      // {
      //   path: '/svc/notiInq',
      //   name: '알림조회',
      //   component: () => import('@/views/svc/notiInq.vue'),
      // },
      // {
      //   path: '/svc/notiMng',
      //   name: '알림관리',
      //   component: () => import('@/views/svc/notiMng.vue'),
      // },
      //운영관리
      {
        path: '/mgr/mngrMng',
        name: '관리자 관리',
        component: () => import('@/views/mgr/mngrMng.vue'),
      },
      {
        path: '/mgr/deptMng',
        name: '부서 관리',
        component: () => import('@/views/mgr/deptMng.vue'),
      },
      {
        path: '/mgr/cdMng',
        name: '코드관리',
        component: () => import('@/views/mgr/cdMng.vue'),
      },
      {
        path: '/mgr/menuMng',
        name: '메뉴관리',
        component: () => import('@/views/mgr/menuMng.vue'),
      },
      {
        path: '/mgr/metadataMng',
        name: '메타데이터관리',
        component: () => import('@/views/mgr/metadataMng.vue'),
      },
      {
        path: '/mgr/authorMng',
        name: '권한관리',
        component: () => import('@/views/mgr/authorMng.vue'),
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // mode: 'history',
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(function (to, from, next) {
  if (to.matched.some((record) => record.meta.unauthorized)) {
    return next()
  }
  // header의 버튼 list 초기화
  store.commit('setButtonList', [])

  const token = localStorage.getItem('token')
  const nav = localStorage.getItem('nav')
  const sidebar = localStorage.getItem('sidebar')
  if (sidebar != null) {
    store.commit('updateSidebar', sidebar)
  }
  // const pageSize = localStorage.getItem('pageSize');
  // if(sidebar != null) {
  //   store.commit("updatePageSize", pageSize);
  // }

  //console.log("menuNav ::: ", store.state.menuNav)
  if (
    token != null &&
    token != '' &&
    token != 'null' &&
    token.accessToken != ''
  ) {
    //access 토큰 만료 체크
    //const accessTokenExpiresIn =JSON.parse(token).accessTokenExpiresIn;
    //const js_date = new Date(accessTokenExpiresIn);
    //console.log(to);
    //if(js_date >= new Date()){
    //console.log("token ::: ", JSON.parse(token))

    store.commit('SET_USER_DATA', JSON.parse(token))
    // 접근한 메뉴에 대한 권한처리(조회, 등록/수정, 삭제, 엑셀다운로드)
    store.commit('SET_USER_MENU_AUTHOR', to.path)
    //공통코드 불러오기
    store.dispatch('setCd')

    if (nav != null && nav != '') {
      store.commit('setMenuNav', JSON.parse(nav))
      if (to.path == '/') {
        const navJson = JSON.parse(nav)
        if (navJson[1].to != null && navJson[1].to != '') {
          router.replace(navJson[1].to)
        } else if (
          navJson[1].items[0].to != null &&
          navJson[1].items[0].to != ''
        ) {
          router.replace(navJson[1].items[0].to)
        }
      }
    } else if (store.state.menuNav.length == 0) {
      let go = null
      if (to.path == '/') {
        go = 'main'
      }
      store.commit('loadMenuNav', go)
    }

    return next()
    //}
  } else {
    //개발 테스트 후 해제
    //alert('로그인 해주세요');
    // 로그인 뒤 원래 가려던 화면으로 돌아간다(예: AI 연결 승인 /ai/connect?...)
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  //return next();
})

export default router
